module.exports = __webpack_public_path__ + "static/media/Slide5.9dc52fef.JPG";